<template>
  <div class="w-full">
    <div class="order rounded px-2 pt-2 pb-8 mb-6">
      <el-row :gutter="20">
        <el-col :span="24" class="mb-6">
          <el-button icon="el-icon-back" size="small"
                     @click="$router.push('/ecommerce/orders')">Back to list</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" class="float-right" plain
                     @click="onDeleteOrder(order.id)">Delete</el-button>
          <el-button v-if="false" type="warning" icon="el-icon-edit" size="small" class="float-right"
                     @click="onEditOrder(order.id)">Edit</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <strong>Order/Inv. No: {{order.invoice_no}}</strong>
        </el-col>
        <el-col :span="24">
          <el-row class="t-hd px-2 py-4">
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="24" class="cus pb-4 pt-1" v-if="order.user">
                  <span v-if="order.user.first_name || order.user.last_name">
                    {{order.user.first_name}} {{order.user.last_name}}</span>
                  <span class="e-m float-right">{{order.user.email}}</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="rw">
                <el-col :span="12" class="pt-1 pb-1">
                  <h4 class="hd">Delivery Info: </h4>
                  <span class="add" v-if="order.deliveryAddress">
                    {{ order.deliveryAddress.first_name }} {{ order.deliveryAddress.last_name }}<br>
                    {{ order.deliveryAddress.address }}
                    <span v-if="order.deliveryAddress.city"> {{ order.deliveryAddress.city }},</span>
                    <span v-if="order.deliveryAddress.zip_code"> {{ order.deliveryAddress.zip_code }}</span>
                    <span v-if="order.deliveryAddress.city"> {{ order.deliveryAddress.city }},</span>
                    <span v-if="order.deliveryAddress.state"> {{ order.deliveryAddress.state }},</span>
                    <span v-if="order.deliveryAddress.country"> {{ order.deliveryAddress.country }}</span><br>
                    <span v-if="order.deliveryAddress.phone"> {{ order.deliveryAddress.phone }}</span>
                  </span>
                  <span v-else>None</span>
                </el-col>
                <el-col :span="12" class="pt-2 pb-2">
                  <h4 class="hd">Billing Info: </h4>
                  <span class="add" v-if="order.billingAddress">
                    {{ order.billingAddress.first_name }} {{ order.billingAddress.last_name }}<br>
                    {{ order.billingAddress.address }}
                    <span v-if="order.billingAddress.city"> {{ order.billingAddress.city }},</span>
                    <span v-if="order.billingAddress.zip_code"> {{ order.billingAddress.zip_code }}</span>
                    <span v-if="order.billingAddress.city"> {{ order.billingAddress.city }},</span>
                    <span v-if="order.billingAddress.state"> {{ order.billingAddress.state }},</span>
                    <span v-if="order.billingAddress.country"> {{ order.billingAddress.country }}</span><br>
                    <span v-if="order.billingAddress.phone"> {{ order.billingAddress.phone }}</span>
                  </span>
                  <span v-else>None</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="rw">
                <el-col :span="12" class="pt-1 pb-1">
                  <span class="hd">Delivered: </span>
                  <template v-if="order.delivered === true"><el-tag size="mini" type="success">Yes</el-tag></template>
                  <template v-else><el-tag size="mini" type="danger">No</el-tag></template>
                </el-col>
                <el-col :span="12" class="pt-1 pb-1">
                  <span class="hd">Order Status: </span>
                  <el-tag size="mini" v-if="order.status">{{order.status.name}}</el-tag>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="rw">
                <el-col :span="12" class="pt-1 pb-1">
                  <span class="hd">Processing Outlet: </span>
                  <span v-if="order.outlet">{{order.outlet.name}}</span>
                </el-col>
                <el-col :span="12" class="pt-1 pb-1">
                  <span class="hd">Ordered: </span>
                  {{order.created_at | moment("from")}}
                </el-col>
              </el-row>
              <el-row :gutter="20" class="rw">
                <el-col :span="12" class="pt-1 pb-1">
                  <span class="hd">Pickup Outlet: </span>
                  <span v-if="order.pickupOutlet">{{order.pickupOutlet.name}}</span>
                </el-col>
                <el-col :span="12" class="pt-1 pb-1">
                  <span class="hd">Est. delivery time: </span>
                  {{ order.est_delivery_time | moment("from", "now") }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="items col-hd py-2">
            <el-col :span="12" class="pt-2 pb-2 px-2">Item</el-col>
            <el-col :span="4" class="pt-2 pb-2 px-2">Qty</el-col>
            <el-col :span="4" class="pt-2 pb-2 px-2">Unit Price</el-col>
            <el-col :span="4" class="pt-2 pb-2 px-2">
              <el-button
                v-if="false"
                size="mini"
                type="info"
                icon="el-icon-plus-outline" @click="$modal.show('new-ordered-item-modal')">Add Item</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="items px-2 py-2"
                  v-for="oItem of order.orderedItems" v-bind:key="oItem.id">
            <el-col :span="12" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-select v-model="selectedItemId" filterable size="mini">
                  <el-option
                    v-for="item of items"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </span>
              <span v-else>{{oItem.item_name}}</span>
            </el-col>
            <el-col :span="4" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-input v-model="selectedItemQty" type="number" size="mini"></el-input>
              </span>
              <span v-else>{{ oItem.quantity }}</span>
            </el-col>
            <el-col :span="4" class="col-item">
              {{ Number(oItem.item_price).toFixed(2) }}
            </el-col>
            <el-col :span="4" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-button @click="updateItem(oItem.id)" size="mini" icon="el-icon-success"
                           type="text" class="text-green-500">Update</el-button>
                <el-button size="mini" icon="el-icon-error" type="text" class="text-red-500"
                           @click="closeEdit()">Cancel</el-button>
              </span>
              <span v-else>
                <el-button v-if="false" @click="editItem(oItem.id, oItem, oItem.quantity)" type="text"
                           icon="el-icon-edit-outline" size="mini">Edit</el-button>
                <el-button @click="deleteItem(oItem.id)" type="text" icon="el-icon-delete-solid"
                           size="mini" class="text-red-500">Remove</el-button>
              </span>
            </el-col>
          </el-row>
          <el-row class="item-sub">
            <el-col :span="16" class="s-t">
              <span class="label">Sub-Total:</span>
            </el-col>
            <el-col :span="8" class="s-t">
              <span>{{Number(orderedItemsTotal).toFixed(2)}}</span>
            </el-col>
            <el-col :span="16" class="s-t">
              <span class="label">Delivery Fee:</span>
            </el-col>
            <el-col :span="8" class="s-t">
              <span>{{Number(order.delivery_amount).toFixed(2)}}</span>
            </el-col>
            <el-col :span="16" class="t-t">
              <span class="label">Grand Total:</span>
            </el-col>
            <el-col :span="8" class="t-t">
              <span>{{Number(orderedItemsTotal + order.delivery_amount).toFixed(2)}} </span>
              <span v-if="order.payment">
                <span v-if="order.payment.failed === false">
                  <el-tag size="mini" type="success">Paid</el-tag>
                </span>
                <span v-else>
                  <el-button size="small" type="text" class="text-l text-red-500 el-icon-warning-outline" @click="openPaymentDetails(order.payment)"> Failed Payment</el-button>
                </span><br>
                <span v-if="order.payment">
                  <small>Payment Method: {{ order.payment.paymentMethod.name }}</small>
                </span>
              </span>
              <span v-else>
                In-Store Payment (PostPaid Pickup)
              </span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24"><br><hr></el-col>
        <el-col :span="24" class="pt-4" v-if="order.deliveryMethod">
          <span class="hd">Delivery method: </span>{{ order.deliveryMethod.name}}
        </el-col>
        <el-col :span="24" class="pt-4">
          <span class="hd">User comment: </span>{{ order.user_comments }}
        </el-col>
        <el-col :span="24" class="pt-4">
          <span class="hd">Admin comment: </span>{{ order.admin_comments }}
        </el-col>
      </el-row>
    </div>
    <NewOrderItemForm :order="order" />
  </div>
</template>

<script>

import NewOrderItemForm from './_includes/NewOrderItemForm.vue';

export default {
  name: 'OrderDetails',
  components: {
    NewOrderItemForm,
  },
  data() {
    return {
      loading: false,
      updating: false,
      editMode: false,
      orderedItemInEditMode: '',
      selectedItemId: '',
      selectedItemQty: '',
    };
  },
  computed: {
    order() {
      return this.$store.state.OrderModule.order;
    },
    items() {
      return this.$store.state.InventoryModule.Products.products;
    },
    orderedItemsTotal() {
      return this.$store.state.OrderModule.orderedItemsTotal;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      this.loading = true;
      await this.$store.dispatch('OrderModule/getOrder', { orderId: this.$route.params.id });
      await this.$store.dispatch('InventoryModule/Products/fetchPluckedProducts');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
    this.loading = false;
  },
  methods: {
    onEditOrder(id) {
      this.$router.push(`/ecommerce/orders/${id}/edit`);
    },
    onDeleteOrder(orderId) {
      this.$confirm('Are you sure you want to delete this order?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('OutletModule/deleteOutlet', { orderId });
          this.$notify.success({
            title: 'Success',
            message: 'Order has been deleted.',
          });
          await this.$router.push('/ecommerce/orders');
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    editItem(orderedItem, item, qty) {
      this.editMode = true;
      this.orderedItemInEditMode = orderedItem;
      this.selectedItemId = item.item_id;
      this.selectedItemQty = qty;
    },
    async updateItem(id) {
      const item = this.items.filter(el => el.id === this.selectedItemId)[0];
      const formData = {
        item_id: this.selectedItemId,
        quantity: this.selectedItemQty,
        item_name: item.name,
        item_price: item.price,
        item_weight: item.weight,
        item_preview: item.image,
      };
      try {
        this.updating = true;
        await this.$store.dispatch('OrderModule/updateOrderItem',
          { orderedItemId: id, orderedItem: formData });
        this.$notify.success({
          title: 'Success',
          message: 'Order update was successful.',
        });
        this.closeEdit();
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.updating = false;
    },
    closeEdit() {
      this.editMode = false;
      this.orderedItemInEditMode = '';
      this.selectedItemId = '';
      this.selectedItemQty = '';
    },
    deleteItem(id) {
      this.$confirm('Are you sure you want to delete this order item?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('OrderModule/deleteOrderItem', { orderId: id });
          this.$notify.success({
            title: 'Success',
            message: 'Order item has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    openPaymentDetails(failedPayment) {
      if (failedPayment) {
        this.$alert(failedPayment.reason, 'Reason for failure', {
          confirmButtonText: 'Close',
        });
      } else {
        this.$alert('Reason not specified', 'Reason for failure', {
          confirmButtonText: 'Close',
        });
      }
    },
    // calculateOrderTotal(param) {
    //   const { columns, data } = param;
    //   const sums = [];
    //   columns.forEach((column, index) => {
    //     if (index === 0) {
    //       sums[index] = 'Total Cost';
    //     }
    //   });
    //   console.log(param);
    //   const values = data.map(item => Number(item[column.property]));
    //   if (!values.every(value => isNaN(value))) {
    //     sums[index] = `$ ${values.reduce((prev, curr) => {
    //       const value = Number(curr);
    //       if (!isNaN(value)) {
    //         return prev + curr;
    //       }
    //       return prev;
    //     }, 0)}`;
    //   } else {
    //     sums[index] = 'N/A';
    //   }
    //   return sums;
    // },
  },
};
</script>

<style scoped lang="scss">
  .order {
    font-size: 14px;
    .hd { font-weight: 500; }
    .t-hd {
      border: 1px solid #eeeeee;
      .cus {
        border-bottom: 1px solid #eeeeee;
        .e-m { font-weight: normal;}
      }
      .rw {
        padding: 5px 0;
        border-bottom: 1px solid #eeeeee;
        .pt-1 { border-right: 1px solid #eeeeee; }
        .pt-1:last-child { border-right: none }
      }
      .rw:last-child { border-bottom: none; }
    }
    .col-hd {
      font-size: 15px;
      font-weight: 500;
      margin-top: 10px;
      background-color: #f9f9f9;
    }
    .items {
      color: #909399;
      .col-item {
        padding-bottom: 6px;
      }
    }
    .item-sub {
      color: #909399;
      border-top: 1px solid #eee;
      margin-bottom: 0;
      .s-t {
        padding: 10px 10px 0 10px;
        .label {padding-right: 15px;}
      }
      .t-t {
        padding: 20px 10px;
        font-weight: 500;
        font-size: 14px;
        .label {padding-right: 15px;}
        .failed-pay {
          font-size: 12px;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
</style>
